// extracted by mini-css-extract-plugin
export var arrow = "_cf-1";
export var content = "_cf-0";
export var highlighted = "_cf-2";